import { createAction } from 'typesafe-actions'

export const setFiats = createAction('SET_FIATS')<string[]>()
